import { render, staticRenderFns } from "./MineMenu.vue?vue&type=template&id=2de99019&scoped=true"
import script from "./MineMenu.vue?vue&type=script&lang=js"
export * from "./MineMenu.vue?vue&type=script&lang=js"
import style0 from "./MineMenu.vue?vue&type=style&index=0&id=2de99019&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de99019",
  null
  
)

export default component.exports